enum ReviewStatus {
  pass = 'pass',
  fail = 'fail',
}

export default ReviewStatus;
